import styled from 'styled-components'
import { colorTheme } from '../../style/theme/colorTheme'
import { theme } from '../../style/theme'

export const CartSettingItemWrap = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	padding: 1.25em;
	gap: 1.25em;
	border-radius: .75em;
	border: 1px solid ${colorTheme.restaurantCartSettings.itemBorder};

	&.lf-col-2 {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 1.25em;
	}

	&.mb-20 {
		margin-bottom: 1.25em;
	}

	&.no-border {
		border: none;
		padding: 0;
	}

	@media screen and (max-width: ${theme.point820}) {
		&.lf-col-2 {
			grid-template-columns: 1fr;
		}
	}
`
CartSettingItemWrap.displayName = 'CartSettingItemWrap'

export const CartSettingItemTitle = styled.div`
	color: ${colorTheme.restaurantCartSettings.title};
	font-family: ${theme.fontRoboto};
	font-size: 1.13em;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
`
CartSettingItemTitle.displayName = 'CartSettingItemTitle'

export const RestaurantCartSettingsTitleWrap = styled.div`
	font-size: 1rem;
	display: flex;
	height: 4.25em;
	padding: .31em 1.25em;
	margin: 1.88em 0;
	align-items: center;
	align-self: stretch;
	background: ${colorTheme.restaurantCartSettings.titleBackground};

	@media screen and (max-width: ${theme.point820}) {
		margin: 1.88em 0 0 0;
		justify-content: center;
	}
`
RestaurantCartSettingsTitleWrap.displayName = 'RestaurantCartSettingsTitleWrap'

export const RestaurantCartSettingsTitle = styled.div`
	color: ${colorTheme.restaurantCartSettings.title};
	font-family: ${theme.fontRoboto};
	font-size: 1.5em;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
`
RestaurantCartSettingsTitle.displayName = 'RestaurantCartSettingsTitle'

export const CartSettingsTitle = styled.div`
	color: ${colorTheme.restaurantCartSettings.title};
	font-family: ${theme.fontRoboto};
	font-size: 1.5em;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
`
CartSettingsTitle.displayName = 'CartSettingsTitle'

export const CartSettingItemContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: .94em;
`
CartSettingItemContent.displayName = 'CartSettingItemContent'
